import { createAsyncThunk } from '@reduxjs/toolkit';
import adserver from 'services/adserver';
import { withErrorHandling } from 'store/wrappers';
import { REDUCER_KEY } from './clients.consts';
import { ClientParams } from './clients.types';

function normalizeApiReponse(data: ClientParams) {
  return data;
}

function normalizeApiRequest(data: ClientParams) {
  return data;
}

const fetchByIdHandler = async ({ clientId }: { clientId: number }) => {
  const client = await adserver({
    url: `/clients/${clientId}/`,
    headers: {},
  });

  return {
    ...client.data,
  };
};

export const fetchAllClients = createAsyncThunk(
  REDUCER_KEY + '/fetchAll',
  withErrorHandling(async () => {
    const response = await adserver({ url: '/clients/', headers: {} });
    return normalizeApiReponse(response.data);
  }),
);

export const fetchById = createAsyncThunk(
  REDUCER_KEY + '/get',
  withErrorHandling(async ({ clientId }: { clientId: number }) => {
    const response = await adserver({
      url: `/clients/${clientId}/`,
      headers: {},
    });
    return normalizeApiReponse(response.data);
  }),
);

export const create = createAsyncThunk(
  REDUCER_KEY + '/create',
  withErrorHandling(async (values: ClientParams) => {
    const response = await adserver({
      url: '/clients/',
      method: 'POST',
      data: normalizeApiRequest(values),
      headers: {},
    });
    return normalizeApiReponse(response.data);
  }),
);

export const update = createAsyncThunk(
  REDUCER_KEY + '/update',
  withErrorHandling(async (data: ClientParams) => {
    const { id: clientId } = data;

    const response = await adserver({
      url: `/clients/${clientId}/`,
      method: 'PATCH',
      data,
      headers: {},
    });
    return response.data;
  }),
);

export const remove = createAsyncThunk(
  REDUCER_KEY + '/remove',
  withErrorHandling(async ({ clientId }: { clientId: number }) => {
    await adserver({
      url: `/clients/${clientId}/`,
      method: 'DELETE',
      headers: {},
    });
    return clientId;
  }),
);

export const setCurrentClient = createAsyncThunk(
  REDUCER_KEY + '/current',
  withErrorHandling(async (clientId: number) => {
    if (!clientId) return;
    const client = await fetchByIdHandler({ clientId });
    return client;
  }),
);

export const removeAllClients = (): { type: string } => ({
  type: REDUCER_KEY + '/removeAll',
});
